// extracted by mini-css-extract-plugin
export default {"row":"SectionRow_row__yfAMt"};